<template>
  <div>
    <p class="m-form-group">
      <label class="a-form-label" for="province"> {{ $t('label-edit-business-province') }} <span :style="{ color: 'red' }">*</span> </label>
      <select class="a-form-control" id="province" v-model="province" autocomplete="province-select">
        <option value="QC">{{ $t("province-qc-label") }}</option>
        <option value="ON">{{ $t("province-on-label") }}</option>
        <option value="NB">{{ $t("province-nb-label") }}</option>
      </select>
    </p>
    <p class="m-form-group">
      <label class="a-form-label" for="region"> {{ $t('label-edit-business-region') }} <span :style="{ color: 'red' }">*</span> </label>
      <select class="a-form-control" id="region" v-model="regionBind" autocomplete="region-select">
        <option disabled value="0">{{ $t("region-choose") }}</option>
        <option v-for="item in regions[province]" :key="item.value" :value="item.value">{{ $t(item.text) }}</option>
      </select>
      <slot></slot>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  data() {
    const regions = {
      QC: [
        { value: 1, text: 'qc-region-1-label' },
        { value: 2, text: 'qc-region-2-label' },
        { value: 3, text: 'qc-region-3-label' },
        { value: 4, text: 'qc-region-4-label' },
        { value: 5, text: 'qc-region-5-label' },
        { value: 6, text: 'qc-region-6-label' },
        { value: 7, text: 'qc-region-7-label' },
        { value: 8, text: 'qc-region-8-label' },
        { value: 9, text: 'qc-region-9-label' },
        { value: 10, text: 'qc-region-10-label' },
        { value: 11, text: 'qc-region-11-label' },
        { value: 12, text: 'qc-region-12-label' },
        { value: 13, text: 'qc-region-13-label' },
        { value: 14, text: 'qc-region-14-label' },
        { value: 15, text: 'qc-region-15-label' },
        { value: 16, text: 'qc-region-16-label' },
        { value: 17, text: 'qc-region-17-label' }
      ],
      ON: [
        { value: 101, text: 'on-region-1-label' },
        { value: 102, text: 'on-region-2-label' },
        { value: 103, text: 'on-region-3-label' },
        { value: 104, text: 'on-region-4-label' },
        { value: 105, text: 'on-region-5-label' },
        { value: 106, text: 'on-region-6-label' },
        { value: 107, text: 'on-region-7-label' },
        { value: 108, text: 'on-region-8-label' },
        { value: 109, text: 'on-region-9-label' },
        { value: 110, text: 'on-region-10-label' },
        { value: 111, text: 'on-region-11-label' },
        { value: 112, text: 'on-region-12-label' },
        { value: 113, text: 'on-region-13a-label' },
        { value: 114, text: 'on-region-13b-label' },
        { value: 115, text: 'on-region-13c-label' }
      ],
      NB: [
        { value: 201, text: 'nb-region-1-label' },
        { value: 202, text: 'nb-region-2-label' },
        { value: 203, text: 'nb-region-3-label' },
        { value: 204, text: 'nb-region-4-label' },
        { value: 205, text: 'nb-region-5-label' },
        { value: 206, text: 'nb-region-6-label' },
        { value: 207, text: 'nb-region-7-label' }
      ]
    }

    // Trouver la province qui contient la région actuellement sélectionée
    let province = Object
      .entries(regions)
      .map(([province, regions]) => ({ province, regions }))
      .filter(x => x.regions.some(r => r.value === this.value))
      .map(x => x.province)
      .at(0);

    // QC par défaut
    if (!province) {
      province = "QC";
    }

    return {
      province,
      regions
    }
  },
  watch: {
    province(current, previous) {
      if (previous && current !== previous && this.value) {
        this.$emit('input', 0)
      }
    }
  },
  computed: {
    regionBind: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
